export default class GIS {
  constructor(options) {
    this.options = options
    GIS._loadScript()
      .then(() => this._open())
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('GIS script failed to load', err)
      })
  }

  _open() {
    // Google rejects short-form client IDs ("…-abc" without the suffix) by
    // silently closing the popup with a popup_closed error_callback — append
    // the canonical suffix if env/config provided the bare ID.
    const clientId = this.options.client_id.endsWith('.apps.googleusercontent.com')
      ? this.options.client_id
      : `${this.options.client_id}.apps.googleusercontent.com`
    const client = window.google.accounts.oauth2.initTokenClient({
      client_id: clientId,
      scope:
        'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
      ux_mode: 'popup',
      callback: (response) => {
        if (response?.access_token) {
          this.options.callback(response.access_token)
        }
      }
    })
    client.requestAccessToken()
  }

  // Each click creates its own token client, so the callback closes over
  // the current GIS instance's options. The previous version stored a
  // singleton token client in `window.gis` whose callback was bound to the
  // very first GIS instance — every subsequent click's callback was lost.
  static _loadScript() {
    if (typeof window === 'undefined') return Promise.reject(new Error('No window'))
    if (window.google?.accounts) return Promise.resolve()
    if (GIS._loadPromise) return GIS._loadPromise
    GIS._loadPromise = new Promise((resolve, reject) => {
      const existing = document.getElementById('gis-js')
      if (existing) {
        existing.addEventListener('load', () => resolve(), { once: true })
        existing.addEventListener('error', reject, { once: true })
        return
      }
      const script = document.createElement('script')
      script.id = 'gis-js'
      script.src = 'https://accounts.google.com/gsi/client'
      script.async = true
      script.defer = true
      script.addEventListener('load', () => resolve(), { once: true })
      script.addEventListener('error', reject, { once: true })
      document.head.appendChild(script)
    })
    return GIS._loadPromise
  }
}
